import React from "react"
import {hasUrlFlag, URL_FLAG__DEBUG} from "../Helper/UrlFlag"
import {useRoomSetup, useSolution} from "../AppContext"
import style from "./Debug.css"

export const Debug = () => {
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const debug = hasUrlFlag(URL_FLAG__DEBUG)
    let elementsCount = 0

    if (!debug) return null

    solution.getItems().map(item => {
        elementsCount += item.elements.length
    })

    return <div className={style.debug}>
        <div>room.id</div>
        <div>{roomSetup.getId()}</div>
        <div>room.type</div>
        <div>{roomSetup.getType()}</div>
        <div>room.shape</div>
        <div>{roomSetup.getShape()}</div>
        <div>room.ceiling</div>
        <div>{roomSetup.getCeilingConstitution()}</div>
        <div>room.wall</div>
        <div>{roomSetup.getWallConstitution()}</div>
        <div>room.floor</div>
        <div>{roomSetup.getFloorConstitution()}</div>
        <div>room.dimensions</div>
        <div>{JSON.stringify(roomSetup.getDimensions())}</div>
        <div>room.interiors (count)</div>
        <div>{roomSetup.getInteriors().length}</div>
        <div>room.diff</div>
        <div>{roomSetup.hasDiff() ? "Yes" : "No"}</div>
        <div>solution.id</div>
        <div>{solution.getId()}</div>
        <div>solution.roomId</div>
        <div>{solution.getRoomId()}</div>
        <div>solution.items (count)</div>
        <div>{solution.getItems().length}</div>
        {solution.getItems().map((item, index) => <>
            <div>solution.item.{index}.sku</div>
            <div>{item.parentSku} | {item.sku}</div>
        </>)}
        <div>solution.elements (count)</div>
        <div>{elementsCount}</div>
        <div>solution.handle.itemId</div>
        <div>{solution.handlerGetItemId()}</div>
        <div>solution.handle.elementIndex</div>
        <div>{solution.handlerGetElementIndex()}</div>
        <div>solution.handle.element.sku</div>
        <div>{solution.getItem()?.parentSku}</div>
    </div>
}
